import { Component, Output, Input, EventEmitter } from '@angular/core';
import { ButtonSeverity } from 'primeng/button';

@Component({
    selector: 'dx-button',
    templateUrl: './buttons.component.html',
    styleUrls: ['./buttons.component.scss'],
    standalone: false
})
export class ButtonComponent {
    @Input() type: "button" |"outline" = "button";
    @Input() text!: string;
    @Input() icon!: string;
    @Input() severity: ButtonSeverity = 'primary';
    @Input() location: "left" | "right" | "center" | "top" | "bottom" = "left"
    @Input() isRounded: boolean = false;
    @Input() variant: "text" | "outlined" | "raised" | "flat" = "raised";
    @Input() disable: boolean = false;
    @Output() onClick = new EventEmitter();
    ngOnInit() {

    }
    handleClick(event: any){
        this.onClick.emit(event);
    }
}
